// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".org-create-color-td {\n  border: 1px solid black;\n}\n\n.org-create-dnd {\n  width: 300px;\n  height: 300px;\n}\n\n.org-create-logo {\n  width: 200px;\n  border: 1px solid black;\n}\n\n.org-create-logo-header {\n  height: 200px;\n  background-color: gray;\n}\n", ""]);
// Exports
module.exports = exports;
